// @core/api/endpoints/workflow/pause_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PausePipelineRequest,
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Pause pipeline
 * Pauses the pipeline. Scheduled triggers and event listeners are disabled. Running executions are not affected.
 */
export async function PausePipeline(
  pipeline_id: string,
  data: PausePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/pause`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
